import Vuex from 'vuex'
import { ApiClient } from '../helpers/api-client/ApiClient'
import vtsApplication from '@/store/modules/vts-application'

export default function store ({ state, mutations, actions, getters, modules }) {
  return new Vuex.Store({
    state: {
      showPreloader: true,
      layout: process.env.VUE_APP_DEFAULT_LAYOUT,
      accessToken: localStorage.getItem('accessToken'),
      expiresIn: localStorage.getItem('expiresIn'),
      refreshToken: localStorage.getItem('refreshToken'),
      user: localStorage.getItem('user') ? localStorage.getItem('user') : null,
      configuration: [],
      transportMarks: [],
      transportModels: [],

      ...state
    },

    mutations: {
      setTransportMarks (state, payload) {
        state.transportMarks = payload
      },

      setTransportModels (state, payload) {
        state.transportModels = payload
      },

      setConfiguration (state, payload) {
        state.configuration = payload
      },

      setShowPreloader (state, payload) {
        state.showPreloader = payload
      },

      setLayout (state, payload) {
        state.layout = payload
      },

      setAccessToken (state, payload) {
        localStorage.setItem('accessToken', payload)
        state.accessToken = payload
      },

      setExpiresIn (state, payload) {
        localStorage.setItem('expiresIn', payload)
        state.expiresIn = payload
      },

      setRefreshToken (state, payload) {
        localStorage.setItem('refreshToken', payload)
        state.refreshToken = payload
      },

      setUser (state, payload) {
        const userInfo = JSON.stringify(payload)
        localStorage.setItem('user', userInfo)
        state.user = userInfo
      },

      ...mutations
    },

    actions: {
      showPreloader (context) {
        context.commit('setShowPreloader', true)
      },

      hidePreloader (context) {
        context.commit('setShowPreloader', false)
      },

      async authorize (context, payload) {
        context.commit('setAccessToken', payload.access_token)
        context.commit('setExpiresIn', payload.expires_in)
        context.commit('setRefreshToken', payload.refresh_token)

        const user = await ApiClient.userMe()
        context.commit('setUser', user.data.data)
      },

      flushAuthorize (context) {
        context.commit('setAccessToken', null)
        context.commit('setExpiresIn', null)
        context.commit('setRefreshToken', null)
        context.commit('setUser', null)
      },

      ...actions
    },

    getters: {
      transportMarks (state) {
        return state.transportMarks
      },

      transportModels (state) {
        return state.transportModels
      },

      configuration (state) {
        return state.configuration
      },

      showPreloader (state) {
        return state.showPreloader
      },

      layout (state) {
        return state.layout
      },

      accessToken (state) {
        return state.accessToken
      },

      expiresIn (state) {
        return state.expiresIn
      },

      refreshToken (state) {
        return state.refreshToken
      },

      user (state) {
        return JSON.parse(state.user)
      },

      isAuthorized (state) {
        return Boolean(state.accessToken)
      },

      ...getters
    },

    modules: {
      vtsApplication,
      ...modules
    }
  })
}
